import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import GroupForm from '../Form';
import { createGroup } from '@resources/Group/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createGroup, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createGroup(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.group.create',
						defaultMessage:
							'A new Group has been successfully created',
					})
				);
				onCancel && onCancel();
				return Promise.resolve(response);
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.group',
					defaultMessage: 'Create Group',
				})}
			</Title>
			<GroupForm {...props} onSubmit={handleSubmit} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createGroup })(Create);
